import { T } from '@/components/i18n/message.i18n.component';
import { Pill } from '@/components/ui/pill/pill.component';
import { InclusionSource, ProductBuildingBlock } from '@/gql/graphql';
import { pretailoringPageMessages } from '@/pages/products/pre-tailoring/pre-tailoring.messages';
import { BuildingBlockDetailsRow } from '../details-building-block.component';

interface Props {
  bb: ProductBuildingBlock;
}

export const GeneralDetailsTab = ({ bb }: Props) => {
  return (
    <>
      <BuildingBlockDetailsRow
        context="maturity-stages"
        label={<T {...pretailoringPageMessages.singleBuildingBlockMaturityStages} />}
        value={
          <div className="flex flex-row gap-2" data-testid="building-block-details-row-maturity-stages">
            {bb.maturityStages?.map((ms) => (
              <Pill
                key={ms.id}
                text={ms.name || ''}
                variant="ms"
                data-testid={`building-block-details-row-maturity-stages-${ms.id}-name`}
              />
            ))}
          </div>
        }
      />
      <BuildingBlockDetailsRow
        context="applicable-for"
        label={<T {...pretailoringPageMessages.singleBuildingBlockApplicableFor} />}
        value={bb.applicableFor}
      />
      {bb.inclusion.source === InclusionSource.Manual && (
        <BuildingBlockDetailsRow
          context="inclusion-explanation"
          label={<T {...pretailoringPageMessages.singleBuidlingBlockInclusionExplanation} />}
          value={bb.inclusion.explanation}
        />
      )}
      <BuildingBlockDetailsRow
        context="target-state"
        label={<T {...pretailoringPageMessages.singleBuildingBlockTargetState} />}
        value={bb.targetState}
      />
      <BuildingBlockDetailsRow
        context="why"
        label={<T {...pretailoringPageMessages.singleBuildingBlockWhy} />}
        value={bb.why}
      />
      <BuildingBlockDetailsRow
        context="consequences-of-no-response"
        label={<T {...pretailoringPageMessages.singleBuildingBlockConsequencesOfNoResponse} />}
        value={bb.consequencesOfNoResponse}
      />
      <BuildingBlockDetailsRow
        context="definition-of-done"
        label={<T {...pretailoringPageMessages.singleBuildingBlockDefinitionOfDone} />}
        value={bb.definitionOfDone}
      />
      <BuildingBlockDetailsRow
        context="precondition-assumptions"
        label={<T {...pretailoringPageMessages.singleBuildingBlockPreconditionAssumptions} />}
        value={bb.preconditionAssumptions}
      />
    </>
  );
};
